import React, { FC } from "react";
import { useSelector } from "react-redux";
import { Controller } from "react-hook-form";

import { ItemsList } from "./ItemsList";
import { TotalSumToPay } from "./TotalSumToPay";
import { Checkbox, Input, Label, Switch } from "../../common";
import { useInvoiceCurrencies } from "../../../hooks/useInvoiceCurrencies";
import { useUpdateInvoiceForm } from "../../../hooks/useUpdateInvoiceForm";
import { selectInvoice } from "../../../store/reducers/invoice";
import { CurrencyType } from "../../../types/InvoiceTypes";

export const InvoiceItemsForm: FC = () => {
  const invoice = useSelector(selectInvoice);
  const invoiceCurrencies = useInvoiceCurrencies(invoice);
  const { control } = useUpdateInvoiceForm(invoice);

  if (!invoice) {
    return <></>;
  }

  const { items_amounts_are_in_outgoing_currency, currency } = invoice;

  const showExactPayoutToggle =
    invoiceCurrencies?.incoming?.type === CurrencyType.FIAT;

  return (
    <div>
      <form className="flex flex-col gap-6">
        {showExactPayoutToggle && (
          <Controller
            control={control}
            defaultValue={items_amounts_are_in_outgoing_currency}
            name="items_amounts_are_in_outgoing_currency"
            render={({ field: { value, ...rest } }) => (
              <Switch
                id="items_amounts_are_in_outgoing_currency"
                checked={value}
                {...rest}
              >
                <div className="flex flex-col gap-0.5">
                  Specify amounts below in {invoiceCurrencies?.outgoing.code}
                  <span className="theme-text-secondary">
                    Final invoice will be in {currency?.toUpperCase()}
                  </span>
                </div>
              </Switch>
            )}
          />
        )}

        <ItemsList control={control} />

        <TotalSumToPay />

        <Controller
          name="show_transaction_data_on_public_view"
          control={control}
          render={({ field, field: { value } }) => (
            <Checkbox {...field} checked={value}>
              <span className="text-gray-300 text-sm">
                Show transaction data on the public view
              </span>
            </Checkbox>
          )}
        />

        <Label label="Notes for client" labelClassName="uppercase">
          <Controller
            name="note"
            control={control}
            render={({ field }) => <Input placeholder="Optional" {...field} />}
          />
        </Label>
      </form>
    </div>
  );
};
